<!-- 
  This HTML contains offscreen Ionic components (like modals and toasts) 
  that are rendered only in development mode to help preload and load 
  necessary Ionic elements quickly. These elements are not meant to be 
  interacted with directly and exist solely to ensure proper loading 
  behavior during development.
-->

<div class="off-screen">
  <h1>Ionic Component Showcase</h1>
<div class="container">

  <ion-popover></ion-popover>
  <!-- Ion Button -->
  <ion-button>Ion Button</ion-button>
  <ion-button color="primary">Primary Button</ion-button>
  <ion-button color="secondary">Secondary Button</ion-button>

  <!-- Ion Alert -->
  <ion-button onclick="showAlert()">Show Alert</ion-button>

  <!-- Ion Input -->
  <ion-item>
    <ion-label position="stacked">Enter Text</ion-label>
    <ion-input placeholder="Type something..."></ion-input>
  </ion-item>

  <!-- Ion Select -->
  <ion-item>
<!-- Add this ion-select somewhere in your template (can be hidden) -->
<ion-select 
  #preloadSelect
  style="position: absolute; left: -9999px; opacity: 0; pointer-events: none;"
  [interfaceOptions]="{
    cssClass: 'offscreen-select'
  }">
  <ion-select-option value="option1">Sample Option 1</ion-select-option>
  <ion-select-option value="option2">Sample Option 2</ion-select-option>
  <ion-select-option value="option3">Sample Option 3</ion-select-option>
</ion-select>
  </ion-item>

  <!-- Ion List -->
  <ion-list>
    <ion-item>List Item 1</ion-item>
    <ion-item>List Item 2</ion-item>
    <ion-item>List Item 3</ion-item>
  </ion-list>

  <!-- Ion Card -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Card Title</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      This is an example of a card component in Ionic.
    </ion-card-content>
  </ion-card>

  <!-- Ion Toggle -->
  <ion-item>
    <ion-label>Enable Feature</ion-label>
    <ion-toggle></ion-toggle>
  </ion-item>

  <!-- Ion Radio Group -->
  <ion-item>
    <ion-label>Choose an Option</ion-label>
    <ion-radio-group>
      <ion-item>
        <ion-label>Option A</ion-label>
        <ion-radio slot="start" value="a"></ion-radio>
      </ion-item>
      <ion-item>
        <ion-label>Option B</ion-label>
        <ion-radio slot="start" value="b"></ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-item>

  <!-- Ion Range -->
  <ion-item>
    <ion-label>Volume</ion-label>
    <ion-range min="0" max="100" step="1" value="50"></ion-range>
  </ion-item>

  <!-- Ion Progress Bar -->
  <ion-progress-bar value="0.6"></ion-progress-bar>

  <!-- Ion Spinner -->
  <ion-spinner name="dots"></ion-spinner>

  <!-- Ion Badge -->
  <ion-badge color="primary">Primary Badge</ion-badge>
  <ion-badge color="secondary">Secondary Badge</ion-badge>

  <!-- Ion Breadcrumbs -->
  <ion-breadcrumbs>
    <ion-breadcrumb>Home</ion-breadcrumb>
    <ion-breadcrumb>Page 1</ion-breadcrumb>
  </ion-breadcrumbs>

  <!-- Ion Fab -->
  <ion-fab vertical="bottom" horizontal="end">
    <ion-fab-button>
   
    </ion-fab-button>
  </ion-fab>

  <!-- Ion Searchbar -->
  <ion-searchbar placeholder="Search"></ion-searchbar>

  <!-- Ion DateTime -->
  <ion-item>
    <ion-label>Date</ion-label>
    <ion-datetime></ion-datetime>
  </ion-item>

  <!-- Ion Modal -->
  <ion-button onclick="showModal()">Show Modal</ion-button>

  <!-- Ion Action Sheet -->
  <ion-button onclick="showActionSheet()">Show Action Sheet</ion-button>
</div>

<ion-modal [isOpen]="false"></ion-modal>

<ion-text color="danger"><ion-icon name="star"></ion-icon>= the main contact</ion-text>
<ion-textarea></ion-textarea>
<ion-datepicker></ion-datepicker>
<ion-checkbox></ion-checkbox>
<ion-chip></ion-chip>
<ion-content><ion-infinite-scroll><ion-infinite-scroll-content></ion-infinite-scroll-content></ion-infinite-scroll></ion-content>
<ion-grid>
  <ion-row>
    <!-- First ion-grid -->
    <ion-col size="6">
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-label>Item 1A</ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-label>Item 1B</ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-col>
